// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT

export const VERSION = '1.0.0';
export const REVISION = 92;

// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT
